module.exports = __webpack_public_path__ + "ca6e9a0c89101a80264285ceaba5c5a7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/text_to_speech_keyboard.png
// module id = 520
// module chunks = 0